
export default {
  data() {
    return {
      announces: [],
      alerts: []
    }
  },
  computed: {
    user() {
      return this.$store.getters.getUser
    }
  },
  created() {
    this.getAnnounces()
    this.$nuxt.$on('makeAnnouncesAsRead', () => {this.getAnnounces()})
    this.getAlerts()
    this.$nuxt.$on('makeAlertsAsRead', () => {this.getAlerts()})
  },
  methods: {
    getAnnounces() {
      const announces_as_read = this.$cookies.get('announces_as_read') ? this.$cookies.get('announces_as_read') : []
      const announces = this.$store.getters.getUser.announces.filter(announce => {
        return !announces_as_read.includes(announce.id)
      })
      this.announces = announces
    },
    getAlerts() {
      const alerts_as_read = this.$cookies.get('alerts_as_read') ? this.$cookies.get('alerts_as_read') : []
      const alerts = this.$store.getters.getUser.alerts.filter(alert => {
        return !alerts_as_read.includes(alert.id)
      })
      this.alerts = alerts
    },
    logout() {
      this.$axios.post('api/logout')
      .then((response) => {
          this.$store.dispatch('setUser', {})
          this.$store.dispatch('setMessages', response.data.messages)
          this.$router.replace({ path: '/login/' })
      })
      .catch((error) => {
          this.$util.errorHandling(error.response)
      })
    }
  }
}
